import type {EventDocument} from 'prismicio-types'
import type {FC} from 'react'
import type {useEventLabels} from '../hooks/useEventLabels'
import {BaseEventsCarousel} from './BaseEventsCarousel'
import {EventCard} from './EventCard'

type EventsCarouselProps = {
  events: EventDocument<string>[]
  labels: ReturnType<typeof useEventLabels>['cards']
}

export const EventsCarousel: FC<EventsCarouselProps> = ({events, labels}) => (
  <BaseEventsCarousel
    items={events}
    renderSlide={(event, _index, isActive) => <EventCard event={event} isActive={isActive} labels={labels} />}
    getSlideKey={(event) => event.id + event.lang}
    containerClassName="gap-6"
  />
)
